// for util functions used in hh platform frontend

export interface InviteResult {
  success: boolean;
  messageKey: string;
  messageParams?: Record<string, string>;
  type: 'success' | 'error' | 'relationCreated';
}

/**
  Date formatter to `yyyy-MM-dd`
 */
export function toBirthDateString(value: Date | string | null | undefined): string {
  if (!value) return '';
  if (typeof value === 'string') return value;
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
  Display formatter for the `yyyy-MM-dd` dates the API returns: `dd-MM-yyyy`.
  Anything that isn't a plain `yyyy-MM-dd` string is passed through untouched.
 */
export function toDisplayDateString(value: string | null | undefined): string {
  if (!value) return '';
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return value;
  const [, year, month, day] = match;
  return `${day}-${month}-${year}`;
}

export function handleInviteResponse(response: any, firstName: string, email: string): InviteResult{
    if (response?.data?.message === 'RELATIONCREATED') {
        return {
          success: true,
          messageKey: 'invite.patientAdded',
          messageParams: { firstName },
          type: 'relationCreated'
        };
      }
      return {
        success: true,
        messageKey: 'invite.inviteSent',
        messageParams: { email },
        type: 'success'
      };
}

const inviteErrorKeys: Record<string, string> = {
  'RELATIONALREADYEXISTS': 'hh_utils.error.RELATIONALREADYEXISTS',
  'USERNOTPATIENT': 'hh_utils.error.USERNOTPATIENT',
  'ENOTAUTHORIZEDTOINVITEFORPRINCIPAL': 'hh_utils.error.ENOTAUTHORIZEDTOINVITEFORPRINCIPAL',
  'EMISSINGDATA': 'hh_utils.error.EMISSINGDATA',
  'EISSUESENDINGEMAIL': 'hh_utils.error.EISSUESENDINGEMAIL',
  'ERRORCREATINGRELATION': 'hh_utils.error.ERRORCREATINGRELATION',
  'EBIRTHDATEMISMATCH': 'hh_utils.error.EBIRTHDATEMISMATCH',
  'EINVITEENOTASSISTANT': 'hh_utils.error.EINVITEENOTASSISTANT',
  'ERELATIONALREADYEXISTS': 'hh_utils.error.ERELATIONALREADYEXISTS',
  'EUSERNOTASSISTANT': 'hh_utils.error.EUSERNOTASSISTANT',
  'USERALREADYEXISTS': 'hh_utils.error.USERALREADYEXISTS',
};

export function handleInviteError(error: any): InviteResult {
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error?.message;

    return {
      success: false,
      messageKey: inviteErrorKeys[errorMessage] || 'hh_utils.error.default',
      type: 'error'
    };
  }


//encode contact email 
export function getContactEmail(): string {
  const user = atob('aW5mbw==');          
  const domain = atob('c2ltcy5sdQ=='); 
  return `${user}@${domain}`;
}
